export class Rota {
    id: number;
    lojistikId: number;
    baslangicId: number;
    varisId: number;
    km: number;
    urunCinsiId: number;
    aracTipiId: number;
    fiyat: number;
    bosDolu: number;
    
  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }
}


export class Guzergah{
  id: number;
    lojistikId: number;
    baslangicId: number;
    varisId: number;
    km: number;
    stokKodu: string;
    aracTipiId: number;
    fiyat: number;
    bosDolu: number;
    fiyatlamaTuru:number;
    
  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }
}